<button mat-stroked-button [class]="'brd-button ' + color" (click)="clickAction($event)" [disabled]="disabled">
  <div class="button-content">
    <mat-icon *ngIf="iconName; else materialIconTemplate" [svgIcon]="iconName"></mat-icon>
    <span>
      {{ text }}
    </span>
  </div>
</button>
<ng-template #materialIconTemplate>
  <mat-icon *ngIf="materialIcon">{{ materialIcon }}</mat-icon>
</ng-template>
